import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import basementsService from './basementsService'
import { faListSquares } from '@fortawesome/free-solid-svg-icons'

const initialState = {
	basements: [],
	isError: false,
	isSuccess: false,
	isLoading: false,
	message: '',
}

export const getBasements = createAsyncThunk('images/getBasements', async (thunkAPI) => {
	try {
		return await basementsService.getBasements()
	} catch (error) {
		const message =
			(error.response && error.response.data && error.response.data.message) ||
			error.message ||
			error.toString()

		return thunkAPI.rejectWithValue(message)
	}
})

export const basementsSlice = createSlice({
	name: 'basements',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getBasements.pending, (state) => {
				state.isLoading = true
			})
			.addCase(getBasements.fulfilled, (state, action) => {
				state.isLoading = false
				state.isSuccess = true
				state.basements = action.payload
			})
			.addCase(getBasements.rejected, (state, action) => {
				state.isLoading = false
				state.isError = true
				state.message = action.payload
			})
	},
})

export default basementsSlice.reducer
